import { SvgIcon } from '@mui/material'

const SvgGroups2 = (props) => (
  <SvgIcon viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" name="SvgGroups2" {...props}>
    <style>
      {
        '.groups2_svg__st3{fill:#d8d5d0}.groups2_svg__st6{fill:#eab599}.groups2_svg__st7{fill:#f6caae}.groups2_svg__st8{fill:#3d4159}.groups2_svg__st9{fill:#fff}.groups2_svg__st10{fill:#bfd5de}.groups2_svg__st12{fill:#d3a489}.groups2_svg__st13{fill:#bf8e75}.groups2_svg__st14{fill:#2a2f4f}'
      }
    </style>
    <path
      d="M205.93 332.215v174.883a252.827 252.827 0 01-37.742-10.562 252.069 252.069 0 01-20.711-8.609 225.883 225.883 0 01-6.855-3.355 251.361 251.361 0 01-17.082-9.488c-27.848-16.863-52.215-38.891-71.797-64.75a255.38 255.38 0 01-29.777-50.449v-27.668c0-32.098 21.797-59.109 51.398-67.02a54.615 54.615 0 013.281-.793 67.09 67.09 0 019.027-1.34 73.366 73.366 0 015.672-.23h45.191c5.047 0 9.969.535 14.715 1.57.27.051.543.113.812.176.797.18 1.602.375 2.383.586.023.012.043.012.062.02a69.012 69.012 0 0121.547 10c18.055 12.525 29.876 33.392 29.876 57.029z"
      fill="#2ba1cf"
    />
    <path
      d="M205.93 332.215v174.883a252.827 252.827 0 01-37.742-10.562 252.069 252.069 0 01-20.711-8.609 225.883 225.883 0 01-6.855-3.355 251.361 251.361 0 01-17.082-9.488c-27.848-16.863-52.215-38.891-71.797-64.75v-78.117c0-32.098 21.797-59.109 51.398-67.02a56.131 56.131 0 013.281-.793 67.281 67.281 0 019.027-1.34 73.389 73.389 0 015.676-.23h15.41c5.047 0 9.969.535 14.715 1.57.27.051.543.113.812.176.797.18 1.602.375 2.383.586.023.012.043.012.062.02a69.012 69.012 0 0121.547 10c18.055 12.525 29.876 33.392 29.876 57.029z"
      fill="#66baed"
    />
    <path
      d="M154.68 264.398l-.164.785-20.758 96.543c-1.992 9.277-10.156 16.004-19.641 16.012h-.352c-9.488-.008-17.648-6.734-19.641-16.012l-20.758-96.535-.164-.793h81.478z"
      fill="#f2f0ec"
    />
    <path
      className="groups2_svg__st3"
      d="M113.941 291.238l-31.238 17.359-9.5-44.199 19.41-11.43M113.941 291.238l31.238 17.359 9.5-44.199-19.41-11.43"
    />
    <path
      d="M20.676 246.109v-104.64c0-10.633 1.773-21.051 5.273-30.965 13.098-37.266 48.461-62.312 87.996-62.312 4.898 0 9.785.379 14.535 1.129 21.719 3.395 41.648 14.48 56.098 31.219a93.274 93.274 0 0122.645 60.93v104.641"
      fill="#cc7a3b"
    />
    <path
      d="M59.043 145.555c0 37.012 21.676 79.832 33.578 100.555H20.672V141.469c0-10.629 1.777-21.047 5.273-30.965 13.02-37.051 48.059-62.023 87.32-62.305-28.675.715-54.222 46.723-54.222 97.356z"
      fill="#a35418"
    />
    <path
      className="groups2_svg__st6"
      d="M138.703 236.105v30.383c0 11.121-7.332 20.523-17.434 23.645a24.65 24.65 0 01-7.324 1.105c-13.672 0-24.75-11.078-24.75-24.75v-30.383h49.508z"
    />
    <path
      className="groups2_svg__st7"
      d="M138.703 264.562v1.926c0 11.121-7.332 20.523-17.434 23.645-9.113-2.801-15.965-10.727-17.23-20.422a84.784 84.784 0 0018.73-.953 84.2 84.2 0 0015.934-4.196zM46.043 186.316c0 11.461-8.371 20.965-19.336 22.727-1.195.195-2.43.297-3.688.297C10.305 209.34 0 199.035 0 186.316c0-12.715 10.305-23.02 23.02-23.02 1.258 0 2.492.102 3.688.297 10.964 1.762 19.335 11.262 19.335 22.723z"
    />
    <path
      className="groups2_svg__st6"
      d="M46.043 186.316c0 11.461-8.371 20.965-19.336 22.727a85.702 85.702 0 01-3.055-22.727 85.665 85.665 0 013.055-22.723c10.965 1.762 19.336 11.262 19.336 22.723z"
    />
    <path className="groups2_svg__st6" d="M31.25 186.316a8.228 8.228 0 11-16.457.003 8.228 8.228 0 0116.457-.003z" />
    <path
      className="groups2_svg__st6"
      d="M173.059 156.922v79.133c-12.23 11.676-27.914 19.762-45.363 22.574l-.422.07a84.627 84.627 0 01-13.328 1.035c-47.301 0-85.648-38.348-85.648-85.648v-32.617c0-4.176.297-8.285.875-12.301 20.379 14.656 49.598 13.207 68.215-4.387 6.164-5.824 10.449-12.758 12.871-20.113 1.348 12.879 7.238 25.414 17.68 35.285 12.428 11.735 28.85 17.395 45.12 16.969z"
    />
    <path
      className="groups2_svg__st7"
      d="M173.059 156.922v79.133c-12.23 11.676-27.914 19.762-45.363 22.574l-.422.07c-40.969-6.402-72.305-41.855-72.305-84.613v-32.617c0-.867.016-1.73.047-2.59 15.102 1.547 30.789-3.148 42.371-14.102 6.164-5.82 10.449-12.758 12.871-20.109 1.348 12.879 7.238 25.414 17.68 35.285 12.429 11.735 28.851 17.395 45.121 16.969z"
    />
    <path
      className="groups2_svg__st6"
      d="M159.949 166.852c0-7.859-6.371-14.227-14.227-14.227s-14.227 6.367-14.227 14.227M96.41 166.852c0-7.859-6.371-14.227-14.227-14.227s-14.223 6.367-14.223 14.227"
    />
    <path
      className="groups2_svg__st8"
      d="M91.902 172.906c0 5.367-4.352 9.719-9.719 9.719s-9.715-4.352-9.715-9.719 4.348-9.715 9.715-9.715 9.719 4.348 9.719 9.715zM155.438 172.906c0 5.367-4.348 9.719-9.715 9.719s-9.715-4.352-9.715-9.719 4.348-9.715 9.715-9.715 9.715 4.348 9.715 9.715z"
    />
    <path
      className="groups2_svg__st6"
      d="M123.672 197.371h-19.434a4.192 4.192 0 010-8.382h19.434a4.192 4.192 0 010 8.382zM113.953 223.891c-7.172 0-14.344-1.797-20.883-5.395a3.809 3.809 0 113.672-6.676c10.777 5.926 23.645 5.926 34.422 0a3.81 3.81 0 013.672 6.676c-6.539 3.598-13.711 5.395-20.883 5.395z"
    />
    <path
      className="groups2_svg__st9"
      d="M89.922 171.191a4.165 4.165 0 11-8.33-.002 4.165 4.165 0 018.33.002zM153.934 171.191a4.162 4.162 0 11-8.324 0 4.162 4.162 0 118.324 0z"
    />
    <path
      className="groups2_svg__st6"
      d="M172.25 196.574c0 5.891-4.777 10.668-10.672 10.668-5.891 0-10.668-4.777-10.668-10.668 0-5.895 4.777-10.672 10.668-10.672 5.895 0 10.672 4.778 10.672 10.672zM76.988 196.574c0 5.891-4.773 10.668-10.668 10.668-5.891 0-10.668-4.777-10.668-10.668 0-5.895 4.777-10.672 10.668-10.672 5.895 0 10.668 4.778 10.668 10.672z"
    />
    <g>
      <path
        className="groups2_svg__st10"
        d="M489.023 330.105v32.047c-25.223 55.285-69.539 100.016-124.512 125.785a253.356 253.356 0 01-30.887 12.066 250.978 250.978 0 01-36.906 8.766.773.773 0 01-.168.023V330.105c0-38.086 29.332-69.332 66.656-72.34a69.551 69.551 0 015.934-.238h47.273c5.59 0 11.031.613 16.258 1.816 32.267 7.376 56.352 36.27 56.352 70.762z"
      />
      <path
        d="M489.023 330.105v32.047c-25.223 55.285-69.539 100.016-124.512 125.785a253.356 253.356 0 01-30.887 12.066V330.105c0-40.082 32.508-72.578 72.602-72.578h10.195c40.106 0 72.602 32.496 72.602 72.578z"
        fill="#dde8ed"
      />
      <path
        className="groups2_svg__st12"
        d="M321.734 177.465c0 11.992-8.758 21.934-20.227 23.777a24.136 24.136 0 01-3.859.309c-13.305 0-24.086-10.781-24.086-24.086s10.781-24.086 24.086-24.086c1.316 0 2.605.105 3.859.309 11.47 1.847 20.227 11.789 20.227 23.777z"
      />
      <path
        className="groups2_svg__st13"
        d="M321.734 177.465c0 11.992-8.758 21.934-20.227 23.777a89.59 89.59 0 01-3.195-23.777 89.63 89.63 0 013.195-23.777c11.47 1.847 20.227 11.789 20.227 23.777z"
      />
      <path
        className="groups2_svg__st13"
        d="M306.258 177.465c0 4.754-3.855 8.609-8.609 8.609s-8.605-3.855-8.605-8.609 3.852-8.605 8.605-8.605 8.609 3.851 8.609 8.605z"
      />
      <path
        className="groups2_svg__st10"
        d="M392.777 287.238l-32.68 18.164-9.941-46.246 20.305-11.961M392.777 287.238l32.684 18.164 9.941-46.246-20.309-11.961"
      />
      <path
        className="groups2_svg__st12"
        d="M463.828 177.465c0 11.992 8.758 21.934 20.227 23.777 1.254.203 2.543.309 3.859.309 13.305 0 24.086-10.781 24.086-24.086s-10.781-24.086-24.086-24.086c-1.316 0-2.605.105-3.859.309-11.469 1.847-20.227 11.789-20.227 23.777z"
      />
      <path
        className="groups2_svg__st13"
        d="M463.828 177.465c0 11.992 8.758 21.934 20.227 23.777a89.427 89.427 0 003.195-23.777 89.466 89.466 0 00-3.195-23.777c-11.469 1.847-20.227 11.789-20.227 23.777z"
      />
      <path
        className="groups2_svg__st13"
        d="M496.523 177.465a8.61 8.61 0 01-17.218 0c0-4.754 3.855-8.605 8.609-8.605s8.609 3.851 8.609 8.605z"
      />
      <path
        className="groups2_svg__st13"
        d="M482.398 164.664c0 44.594-32.578 81.59-75.234 88.457a88.472 88.472 0 01-14.383 1.156c-49.496 0-89.613-40.117-89.613-89.613 0-23.418 8.133-58.574 22.84-74.539 16.375-17.777 40.695-15.078 66.773-15.078 4.902 0 9.703.391 14.383 1.16 42.656 6.867 75.234 43.859 75.234 88.457z"
      />
      <path
        className="groups2_svg__st13"
        d="M418.684 229.559v31.785c0 11.637-7.672 21.473-18.242 24.738a25.85 25.85 0 01-7.664 1.156c-14.301 0-25.895-11.594-25.895-25.895v-31.785h51.801z"
      />
      <path
        className="groups2_svg__st12"
        d="M418.684 259.328v2.016c0 11.637-7.672 21.473-18.242 24.738-9.535-2.93-16.703-11.223-18.027-21.367 1.73.105 3.469.16 5.219.16 4.898 0 9.703-.391 14.383-1.156a88.12 88.12 0 0016.667-4.391zM482.398 164.664c0 44.594-32.578 81.59-75.234 88.457-42.652-6.867-75.23-43.863-75.23-88.457 0-27.461 12.352-52.039 31.809-68.48 12.133-10.258 27.035-17.34 43.422-19.98 39.766 6.402 70.785 39 74.793 79.523.292 2.941.44 5.925.44 8.937z"
      />
      <path
        className="groups2_svg__st13"
        d="M392.785 208.801c-7.508 0-15.008-1.879-21.848-5.641a3.98 3.98 0 01-1.574-5.414 3.982 3.982 0 015.414-1.57c11.273 6.195 24.738 6.195 36.016 0a3.98 3.98 0 015.41 1.57 3.984 3.984 0 01-1.57 5.414c-6.84 3.762-14.348 5.641-21.848 5.641z"
      />
      <path
        className="groups2_svg__st8"
        d="M373.699 159.449c0 5.613-4.551 10.164-10.168 10.164-5.613 0-10.164-4.551-10.164-10.164 0-5.617 4.551-10.168 10.164-10.168a10.166 10.166 0 0110.168 10.168zM432.199 159.449c0 5.613-4.551 10.164-10.164 10.164-5.617 0-10.168-4.551-10.168-10.164a10.166 10.166 0 0110.168-10.168c5.613 0 10.164 4.551 10.164 10.168z"
      />
      <path
        className="groups2_svg__st9"
        d="M371.625 157.652c0 2.406-1.949 4.359-4.355 4.359a4.357 4.357 0 010-8.714 4.357 4.357 0 014.355 4.355zM430.625 157.652c0 2.406-1.949 4.359-4.355 4.359a4.357 4.357 0 010-8.714 4.357 4.357 0 014.355 4.355z"
      />
      <path
        className="groups2_svg__st13"
        d="M402.949 185.043h-20.332a4.385 4.385 0 110-8.77h20.332a4.385 4.385 0 110 8.77z"
      />
      <path className="groups2_svg__st10" d="M422.289 327.727h39.066v11.957h-39.066v-11.957z" />
      <path
        className="groups2_svg__st14"
        d="M387.539 49.449c27.148 1.938 48.945 23.867 50.324 51.473l.258 5.184h15.617l8.41 55.93 20.371-6.305-2.734-54.805c-1.445-29-25.43-51.727-54.453-51.617l-37.793.14z"
      />
      <path
        className="groups2_svg__st8"
        d="M478.059 27.816c21.617 21.617 21.617 56.668 0 78.285s-56.668 21.617-78.285 0l78.285-78.285z"
      />
      <path
        className="groups2_svg__st8"
        d="M399.773 106.102h-67.938l-8.414 55.934-20.371-6.305 2.73-54.809c1.445-28.992 25.43-51.727 54.457-51.617l98.121.371 12.973 23.348"
      />
      <path
        className="groups2_svg__st14"
        d="M398.027 49.449c-27.148 1.938-48.945 23.867-50.324 51.473l-.258 5.184h-15.613l-8.414 55.93-20.371-6.305 2.734-54.805c1.445-29 25.43-51.727 54.453-51.617l37.793.14z"
      />
    </g>
    <g>
      <path
        className="groups2_svg__st8"
        d="M364.512 468.742v19.195C331.566 503.371 294.797 512 256 512s-75.578-8.629-108.523-24.074v-19.184c0-37.879 25.715-69.738 60.645-79.078a77.845 77.845 0 013.867-.941 80.926 80.926 0 0110.648-1.566 82.541 82.541 0 016.699-.273h53.309c5.965 0 11.766.629 17.367 1.84.324.062.648.137.961.211.941.219 1.879.449 2.809.699.035.008.043.008.074.02a81.289 81.289 0 0125.414 11.797c21.304 14.776 35.242 39.401 35.242 67.291z"
      />
      <path
        className="groups2_svg__st3"
        d="M255.988 420.395l-36.855 20.48-11.211-52.145 22.898-13.488M255.988 420.395l36.852 20.48 11.211-52.145-22.898-13.488"
      />
      <path
        className="groups2_svg__st6"
        d="M285.199 355.352v35.84c0 13.125-8.652 24.215-20.57 27.898a29.115 29.115 0 01-8.645 1.305c-16.129 0-29.199-13.074-29.199-29.203v-35.84h58.414z"
      />
      <path
        className="groups2_svg__st7"
        d="M285.199 388.922v2.273c0 13.121-8.652 24.211-20.57 27.898-10.754-3.309-18.84-12.656-20.332-24.098a100.388 100.388 0 0022.102-1.121 99.495 99.495 0 0018.8-4.952zM175.875 296.609c0 13.52-9.879 24.73-22.812 26.812a27.423 27.423 0 01-4.348.348c-15.004 0-27.164-12.156-27.164-27.16s12.156-27.164 27.164-27.164c1.48 0 2.934.121 4.348.352 12.933 2.082 22.812 13.293 22.812 26.812z"
      />
      <path
        className="groups2_svg__st6"
        d="M175.875 296.609c0 13.52-9.879 24.73-22.812 26.812a101.048 101.048 0 01-3.602-26.812c0-9.281 1.254-18.27 3.602-26.812 12.933 2.082 22.812 13.293 22.812 26.812z"
      />
      <path
        className="groups2_svg__st6"
        d="M158.422 296.609c0 5.359-4.348 9.707-9.707 9.707-5.363 0-9.707-4.348-9.707-9.707a9.704 9.704 0 019.707-9.707c5.359 0 9.707 4.344 9.707 9.707z"
      />
      <path
        className="groups2_svg__st7"
        d="M336.105 296.609c0 13.52 9.879 24.73 22.812 26.812 1.41.227 2.867.348 4.348.348 15.004 0 27.164-12.156 27.164-27.16s-12.156-27.164-27.164-27.164c-1.48 0-2.938.121-4.348.352-12.933 2.082-22.812 13.293-22.812 26.812z"
      />
      <path
        className="groups2_svg__st6"
        d="M336.105 296.609c0 13.52 9.879 24.73 22.812 26.812a101.048 101.048 0 003.602-26.812c0-9.281-1.254-18.27-3.602-26.812-12.933 2.082-22.812 13.293-22.812 26.812z"
      />
      <path
        className="groups2_svg__st6"
        d="M357.047 243.695v38.48c0 50.289-36.738 92.004-84.84 99.746l-.492.082c-5.117.82-10.367 1.223-15.727 1.223-55.809 0-101.047-45.242-101.047-101.047v-38.484c0-11.75 2.004-23.043 5.707-33.535 13.82-39.328 51.293-67.523 95.34-67.523h.008c5.352 0 10.609.414 15.734 1.223 48.336 7.55 85.317 49.378 85.317 99.835z"
      />
      <path
        className="groups2_svg__st6"
        d="M372.973 296.609c0 5.359-4.344 9.707-9.707 9.707-5.359 0-9.707-4.348-9.707-9.707 0-5.363 4.348-9.707 9.707-9.707a9.704 9.704 0 019.707 9.707z"
      />
      <path
        className="groups2_svg__st7"
        d="M357.043 243.695v38.48c0 50.285-36.734 92.004-84.836 99.746l-.496.082c-48.332-7.555-85.305-49.379-85.305-99.828v-38.48c0-50.457 36.98-92.285 85.324-99.836 48.336 7.551 85.313 49.379 85.313 99.836z"
      />
      <path
        className="groups2_svg__st8"
        d="M234.469 276.289c0 6.332-5.133 11.465-11.461 11.465-6.332 0-11.465-5.133-11.465-11.465 0-6.328 5.133-11.461 11.465-11.461 6.328 0 11.461 5.133 11.461 11.461zM300.441 276.289c0 6.332-5.133 11.465-11.465 11.465s-11.465-5.133-11.465-11.465c0-6.328 5.133-11.461 11.465-11.461s11.465 5.133 11.465 11.461z"
      />
      <path
        className="groups2_svg__st9"
        d="M232.133 274.27a4.912 4.912 0 11-9.824-.004 4.912 4.912 0 019.824.004zM298.664 274.27a4.912 4.912 0 11-4.91-4.914 4.911 4.911 0 014.91 4.914z"
      />
      <path
        className="groups2_svg__st6"
        d="M267.457 300.66h-22.93a4.946 4.946 0 01-4.945-4.945 4.944 4.944 0 014.945-4.945h22.93a4.944 4.944 0 110 9.89zM255.992 331.945c-8.461 0-16.926-2.121-24.637-6.363a4.489 4.489 0 01-1.773-6.102 4.5 4.5 0 016.105-1.777c12.715 6.992 27.895 6.992 40.609 0a4.494 4.494 0 016.105 1.777 4.49 4.49 0 01-1.773 6.102c-7.714 4.242-16.175 6.363-24.636 6.363z"
      />
      <path
        className="groups2_svg__st14"
        d="M357.047 208.773v39.418h-18.809V217.32l-135.766-25.227-28.727-5.34v61.438h-18.809V208.77c0-44.938 36.422-81.359 81.352-81.359h39.406c1.07 0 2.141.02 3.211.074 43.435 1.671 78.142 37.421 78.142 81.288z"
      />
      <path
        className="groups2_svg__st8"
        d="M357.047 208.773v39.418h-18.809V217.32l-135.766-25.227c7.48-35.93 38.652-63.152 76.434-64.609 43.434 1.672 78.141 37.422 78.141 81.289z"
      />
    </g>
  </SvgIcon>
)

export default SvgGroups2
